__turbopack_context__.v({
  "videoContainer": "LazyVideo-module-scss-module__DzPLLa__videoContainer",
});
